import { FC, useState } from 'react';
import {
  Tabs, TabList, Tab, TabPanels, TabPanel,
} from '@reach/tabs';
import '@reach/tabs/styles.css';
import { useTranslation } from 'next-i18next';
import ListOfLinks from './ListOfLinks';
import type { HomepageWorldwideLocationsData } from './types';
import styles from './HomepageWorldwideLocations.module.scss';

const tabs = [
  'cities',
  'lakes',
  'states',
  'internationalCities',
  'countries',
];

type HomepageWorldwideLocationsProps = {
  data: HomepageWorldwideLocationsData;
};

const HomepageWorldwideLocations: FC<HomepageWorldwideLocationsProps> = ({ data }) => {
  const [expand, setExpand] = useState(false);
  const {
    cities, internationalCities, states, lakes, countries,
  } = data;

  const [t] = useTranslation('worldwide-locations');
  const locationsCount = Number(9400).toLocaleString();
  const onShowMoreClick = () => {
    setExpand(true);
  };

  return (
    <div className={styles.root}>
      <h3>{t('worldwide-locations--title', { locationsCount })}</h3>
      <Tabs>
        <TabList>
          {tabs.map((key) => (
            <Tab key={key}>{t(key)}</Tab>
          ))}
        </TabList>
        <TabPanels>
          <TabPanel>
            <ListOfLinks
              expand={expand}
              onShowMoreClick={onShowMoreClick}
              links={cities}
            />
          </TabPanel>
          <TabPanel>
            <ListOfLinks
              expand={expand}
              onShowMoreClick={onShowMoreClick}
              links={lakes}
            />
          </TabPanel>
          <TabPanel>
            <ListOfLinks
              expand={expand}
              onShowMoreClick={onShowMoreClick}
              links={states}
            />
          </TabPanel>
          <TabPanel>
            <ListOfLinks
              expand={expand}
              onShowMoreClick={onShowMoreClick}
              links={internationalCities}
            />
          </TabPanel>
          <TabPanel>
            <ListOfLinks
              expand={expand}
              onShowMoreClick={onShowMoreClick}
              links={countries}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  );
};

export default HomepageWorldwideLocations;
